import { Users, StickyNote, Repeat } from 'lucide-react';
import { STAVY, cas, cil, naDatum, posun, zasahujeDen } from './rezervaceUi';
import { SECTION_COLOR } from '../objednavky/ui';

/** Týden po dnech — sloupec je den, klik na hlavičku otevře jeho osu. */
export default function Tyden({ od, rezervace, borderColor, mutedColor, vybranyId = null, onOtevrit, onDen }) {
    const dny = Array.from({ length: 7 }, (_, i) => posun(od, i));
    const dnesek = naDatum(new Date());

    return (
        <div className="grid gap-2" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', padding: 12 }}>
            {dny.map(d => {
                const denni = rezervace
                    .filter(r => zasahujeDen(r, d) && r.stav !== 'zrusena')
                    .sort((a, b) => a.zacatek.localeCompare(b.zacatek));
                const hostu = denni.reduce((n, r) => n + r.pocet_hostu, 0);

                return (
                    <div key={d} className="rounded-xl flex flex-col"
                        style={{ border: `1px solid ${d === dnesek ? SECTION_COLOR : borderColor}`, minHeight: 160 }}>
                        <button type="button" onClick={() => onDen(d)}
                            className="flex items-baseline justify-between px-3 py-2"
                            style={{ borderBottom: `1px solid ${borderColor}`, background: 'none', borderTop: 'none', borderLeft: 'none', borderRight: 'none', cursor: 'pointer' }}>
                            <span className="text-xs font-bold capitalize"
                                style={{ color: d === dnesek ? SECTION_COLOR : 'var(--text-primary)' }}>
                                {new Date(`${d}T12:00:00`).toLocaleDateString('cs-CZ', { weekday: 'short', day: 'numeric' })}
                            </span>
                            {hostu > 0 && (
                                <span className="flex items-center gap-0.5 text-[10px]" style={{ color: mutedColor }}>
                                    <Users size={9} />{hostu}
                                </span>
                            )}
                        </button>

                        <div className="flex-1 p-2 flex flex-col gap-1">
                            {denni.length === 0 ? (
                                <div className="text-[10px] text-center pt-2" style={{ color: mutedColor }}>—</div>
                            ) : denni.map(r => {
                                const barva = (STAVY[r.stav] || STAVY.potvrzena).color;
                                return (
                                    <button key={r.id} type="button" onClick={() => onOtevrit(r)}
                                        className="text-left px-2 py-1"
                                        style={{
                                            borderRadius: 6, background: `${barva}1f`, cursor: 'pointer',
                                            border: `1px solid ${r.id === vybranyId ? barva : `${barva}44`}`,
                                        }}>
                                        <div className="flex items-center gap-1">
                                            <span className="text-[11px] font-bold" style={{ color: barva }}>
                                                {r.cely_den ? 'celý den' : cas(r.zacatek)}
                                            </span>
                                            <span className="flex items-center gap-0.5 text-[10px]" style={{ color: mutedColor }}>
                                                <Users size={8} />{r.pocet_hostu}
                                            </span>
                                            {r.serie_id && <Repeat size={8} style={{ color: mutedColor }} />}
                                            {r.poznamka && <StickyNote size={8} style={{ color: mutedColor }} />}
                                        </div>
                                        <div className="text-[11px] truncate" style={{ color: 'var(--text-primary)' }}>{r.jmeno}</div>
                                        <div className="text-[10px] truncate" style={{ color: mutedColor }}>{cil(r)}</div>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
